module.exports = __webpack_public_path__ + "static/icons/icon-beach-761eafd518e0cee4da6077204143cecc.svg";